import React, { Component } from 'react';
import { AutoSizer, List } from 'react-virtualized';
import { Scrollbars } from 'react-custom-scrollbars';

export default class WindowedList extends Component {

    componentDidMount() {
            
        this.list.Grid._scrollingContainer = this.scroll.view;
    }
    
    handleScroll = (e) => {
        this.list.Grid._onScroll(e);
    }

    render() {

        return (
            <div style={{ height: this.props.height }}>
                <AutoSizer>
                {({ height, width }) => (
                    <Scrollbars style={{ height: height, width: width }}  ref={node => this.scroll = node} onScroll={this.handleScroll} >
                        <List
                            ref={node => this.list = node}
                            style={{ overflowX: 'visible', overflowY: 'visible' }}
                            width={this.props.scrollbarOverlay ?  width : width  - 20}
                            height={height}
                            rowCount={this.props.rowCount}
                            rowHeight={this.props.rowHeight}
                            rowRenderer={this.props.rowRenderer}
                        />
                    </Scrollbars>
                )}
                </AutoSizer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/windowedList/index.jsx